import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import OverlayHandle from '../../atoms/progressbar-overlay-handle';
import { flattenHTMLChildren } from '../../../utils/react-children-utils/react-children-utils';

const ProgressBarOverlay = function ProgressBarOverlay(props) {
    const { contextname, sourceuri } = props;
    const [left, setLeft] = useState(0);
    const [widgetApp, setWidgetApp] = useState(null);

    function findWidget() {
        if (widgetApp) {
            // if we have the widgetApp, don't do another document scan
            return widgetApp;
        }

        const widgets = document.getElementsByTagName('progresswidgetapp');
        const widget = widgets.length
            ? [...widgets].find((w) => w.dataset.contextname === contextname)
            : widgets;

        if (widget) {
            setWidgetApp(widget);
        }

        return widget;
    }

    function setPositioning() {
        // get the left style property of the 'icon-handle-bar' element to sync the overlay with.
        if (widgetApp) {
            const element = flattenHTMLChildren(widgetApp.children)
                .find((c) => c.dataset.id === `icon-handle-${contextname}`);

            if (element) {
                const positioning = element.parentElement.offsetLeft;
                // minus 25px as we have a fixed width of 50px and we want to center the image
                // we need to confirm about the specs of 50x50px for the icon
                // and whether we want to center, front or back of progress bar icon handle.
                const newLeft = positioning - 25;

                if (newLeft !== left) {
                    setLeft(newLeft);
                }
            }
        }
    }

    function calculateBarWidth(bar) {
        // width for container == width of bar minus side padding
        const containerWidth = bar.clientWidth;

        const leftPadding = window.getComputedStyle(bar, null).getPropertyValue('padding-left');
        const rightPadding = window.getComputedStyle(bar, null).getPropertyValue('padding-right');

        const leftPaddingInt = parseInt(leftPadding.substring(0, leftPadding.length - 2), 10);
        const rightPaddingInt = parseInt(rightPadding.substring(0, rightPadding.length - 2), 10);

        return containerWidth - leftPaddingInt - rightPaddingInt;
    }

    function insertOverlay() {
        // there are two 'progresswidgetapp' elements for each progress bar.
        // We need the nested one and we can identify it by it having the  data-odataurl attribute.
        const widget = findWidget();

        const widgetChildren = flattenHTMLChildren(widget.children);
        const bar = widgetChildren.find((c) => c.dataset.id === `icon-target-${contextname}`);

        if (!bar) {
            return null;
        }

        // we need to make sure that the overlay image container is the same width and margin.
        // this ensures that we can sync the left properties of both elements
        const overlayWidth = calculateBarWidth(bar);
        const overlayMargin = `0 ${window.getComputedStyle(bar, null).getPropertyValue('padding-left')}`;

        const target = widgetChildren.find((c) => c.dataset.id === `icon-container-${contextname}`);

        return (
            <OverlayHandle
                target={target}
                className={styles.overlay}
                style={{
                    width: overlayWidth,
                    margin: overlayMargin,
                }}
            >
                <div className={styles['overlay-image']} style={{ background: `url("${sourceuri}")`, left }} />
            </OverlayHandle>
        );
    }

    useEffect(() => {
        if (contextname) {
            setInterval(() => {
                findWidget();

                // we need to poll for the overlay progress to sync the position of the image.
                setPositioning();
            }, 100);
        }
    }, []);

    return insertOverlay();
};

ProgressBarOverlay.propTypes = {
    contextname: PropTypes.string,
    sourceuri: PropTypes.string.isRequired, // this should be a svg data uri
};

ProgressBarOverlay.defaultProps = {
    contextname: 'bar',
};

export default ProgressBarOverlay;
